var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAggregatorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 6,
    viewBox: "0 0 16 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#061E37",
    d: "M9.87096774,3 L13.483871,3 C13.7689212,3 14,3.26862915 14,3.6 L14,8.4 C14,8.73137085 13.7689212,9 13.483871,9 L9.87096774,9 L6.25806452,9 L2.64516129,9 L-1.48387097,9 C-1.76892116,9 -2,8.73137085 -2,8.4 L-2,3.6 C-2,3.26862915 -1.76892116,3 -1.48387097,3 L2.64516129,3 L6.25806452,3 L9.87096774,3 Z M10.3870968,4.8 L10.3870968,7.2 L12.4516129,7.2 L12.4516129,4.8 L10.3870968,4.8 Z M8.83870968,4.8 L6.77419355,4.8 L6.77419355,7.2 L8.83870968,7.2 L8.83870968,4.8 Z M5.22580645,7.2 L5.22580645,4.8 L3.16129032,4.8 L3.16129032,7.2 L5.22580645,7.2 Z M1.61290323,7.2 L1.61290323,4.8 L-0.451612903,4.8 L-0.451612903,7.2 L1.61290323,7.2 Z",
    transform: "translate(2 -3)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAggregatorIcon);
export default __webpack_public_path__ + "static/media/aggregator-icon.e0dd4c3438545b36bedbc009ba82b9d1.svg";
export { ForwardRef as ReactComponent };